export const constants = {
  TON_DECIMALS: 9,
  TOKEN_DECIMALS: 6,
}